// extracted by mini-css-extract-plugin
export default {"buttonColor":"#fff"};